/* eslint-disable */

import SlidesFi from './SlidesFi'
import SlidesEn from './SlidesEn'
import SlidesSv from './SlidesSv'

export default {
  animating: false,
  scrollDuration: 600,
  idleTimeout: 10 * 60 * 1000,
  isIdle: false,
  currentSlide: 0,
  defaultLang: 'Fi',
  currentLanguage: 'Fi',
  languages: [
    {langCode: 'Fi'},
    {langCode: 'Sw'},
    {langCode: 'En'}
  ],
  easings: {
    easeInOutExpo: function (x, t, b, c, d) {
      if (t === 0) return b
      if (t === d) return b + c
      if ((t /= d / 2) < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b
      return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b
    }
  },
  slides: {
    Fi: SlidesFi,
    En: SlidesEn,
    Sw: SlidesSv
  }
}



// WEBPACK FOOTER //
// ./src/State.js